import { Checkbox } from '@creditornot/cb-checkbox';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import styled from 'styled-components';
import { css } from 'styled-components';

export const SelectedCheckbox = styled(Checkbox)<{ checked?: boolean }>`
  display: ${({ checked }) => (checked ? 'block' : 'none')};

  & > label > div {
    width: 20px;
    height: 20px;

    & > div {
      border-radius: 10px;
      border-color: ${({ checked }) => (checked ? cbSemanticCssVars.borderPrimary : 'transparent')};
      background-color: ${({ checked }) => (checked ? 'inherit' : cbSemanticCssVars.surfaceMain)};
    }
  }
`;

export const ImageContainer = styled.div<{
  $dragged?: boolean;
  $selected?: boolean;
  $draggable?: boolean;
  $clickable?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 168px;
  border-radius: 8px;
  background-color: ${color.bgSurface};
  border: 1px solid ${({ $selected }) => ($selected ? color.borderSelected : color.border)};
  overflow: hidden;
  cursor: ${({ $draggable, $clickable }) => ($draggable ? 'grab' : $clickable ? 'pointer' : 'default')};

  &:hover {
    ${SelectedCheckbox} {
      display: block;
    }
  }
`;

export const ImageFrame = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
  background-color: ${cbSemanticCssVars.borderPrimary};
`;

export const ImageName = styled.span`
  ${typographyCss.Overline3()}
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  flex-shrink: 0;
  padding: 8px 12px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  outline: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const ImageOverlayItemsContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 8px;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: 100%;
  padding: 8px;
  justify-content: space-between;
`;

export const ImageOverlayItemsGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const cardShimmerStyle = css`
  position: relative;
  overflow: hidden;
  background-color: ${cbSemanticCssVars.borderPrimary};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent 0, ${cbSemanticCssVars.surfaceMain} 80%, transparent);
    animation: shimmer 1200ms infinite;
    opacity: 0.7;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;
